import { ga } from 'js/analytics/adapters'

export const trackAppStoreButtonClick = ({ type }) => {
  ga.track('app_store_buttons_click', {
    type,
  })
}
